<style lang="scss" scoped>
  .board {
    min-height: 500px;
  }
</style>

<template>
  <section class="tenant-upgrade">
    <div class="row">
      <div class="col-12 d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ __('Você não tem acesso') }}
        </h2>
      </div>
    </div>
    <div class="board with-shadowS" />
  </section>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  mounted () {
    Swal.fire({
      width: 480,
      html: `<div class="top">${this.__('Você não tem acesso')}.</div>`
          + `<div class="title">${this.__('Faça o upgrade<br>da sua conta')}.</div>`
          + '<div class="my-20px"><img src="/build/icons/prototype.png" alt="Protótipo"></div>'
          + `<div>${this.__('Fazendo o upgrade, você pode visualizar')}<br>`
          + `${this.__('esta e outras novas funcionalidades')}.</div>`
          + `<div class="f-w-700">${this.__('Faça agora mesmo')}.</div>`,
      buttonsStyling: false,
      confirmButtonClass: 'btn btn-primary',
      confirmButtonText: this.__('Upgrade da conta'),
      cancelButtonColor: 'transparent',
      cancelButtonText: this.__('Agora não'),
      customClass: {
        container: 'container-swal2-upgrade',
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
      },
    }).then((result) => {
      if (result.value) {
        window.location = '/billing';
      }

      if (result.dismiss === 'cancel') {
        window.location = '/';
      }
    });
  },
};
</script>
